import React, { useState, createContext } from "react";
// interface
import { IPartner, IPartnerMinimum } from "@src/api/partner/partner";
import {
  IPhotoProviderData,
  IPhotoData,
  ISelectedFolder,
  ISelectedPhoto,
  TTabType,
} from "./Interface";
import { TPartnerType } from "../interface";

// provider data
export const PhotoProviderData = createContext<null | {
  data: IPhotoProviderData;
  setData?: React.Dispatch<React.SetStateAction<IPhotoProviderData>>;
}>(null);

/**
 *
 * provider component
 * @param partnerDataProvider 파트너 데이터
 * @param apiFunctionProvider api 함수 제공
 * @param tabNumberProvider 탭 번호
 * @param partnerTypeProvider 파트너 타입
 * @param children 자식 컴포넌트
 */
export const PhotoProviderComponent = ({
  partnerDataProvider,
  apiFunctionProvider,
  parentTabNumberProvider,
  partnerTypeProvider,
  children,
}: {
  partnerDataProvider?: IPartner | IPartnerMinimum;
  apiFunctionProvider: any;
  parentTabNumberProvider: number;
  partnerTypeProvider?: TPartnerType;
  children: React.ReactNode;
}) => {
  // 파트너 데이터
  const [partner, setPartner] = useState<IPartner | IPartnerMinimum | null>(
    partnerDataProvider || null,
  );
  const [officialPhotoData, setOfficialPhotoData] = useState<null | IPhotoData[]>(null);
  const [reviewPhotoData, setReviewPhotoData] = useState<null | IPhotoData[]>(null);
  const [selectedPhoto, setSelectedPhoto] = useState<null | ISelectedPhoto>(null);
  const [activePhotoTab, setActivePhotoTab] = useState<TTabType>(0);
  const [officialPhotoTotal, setOfficialPhotoTotal] = useState<number>(0);
  const [reviewPhotoTotal, setReviewPhotoTotal] = useState<number>(0);
  const [selectedFolder, setSelectedFolder] = useState<null | ISelectedFolder>(null);

  return (
    <PhotoProviderData.Provider
      value={{
        data: {
          partner,
          setPartner,
          partnerType: partnerTypeProvider ? partnerTypeProvider : "default",
          parentTabNumber: parentTabNumberProvider,
          getOfficialPhoto: apiFunctionProvider.getOfficialPhoto,
          getReviewPhoto: apiFunctionProvider.getReviewPhoto,
          getFolderPhoto: apiFunctionProvider.getFolderPhoto,
          officialPhotoData,
          setOfficialPhotoData,
          reviewPhotoData,
          setReviewPhotoData,
          selectedPhoto,
          setSelectedPhoto,
          selectedFolder,
          setSelectedFolder,
          activePhotoTab,
          setActivePhotoTab,
          officialPhotoTotal,
          setOfficialPhotoTotal,
          reviewPhotoTotal,
          setReviewPhotoTotal,
        },
      }}
    >
      {children}
    </PhotoProviderData.Provider>
  );
};
